module.exports = __webpack_public_path__ + "static/media/globle.62f8fea8.svg";